import type { ReactNode } from "react"
import { Logo } from "./logo"
import { Card, CardDescription, CardTitle } from "./ui/card"

export function AuthLayout(props: {
  title: string
  description: string
  children: ReactNode
  footer: ReactNode
}) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 px-4 py-10">
      <Logo />
      <Card className="w-full max-w-sm">
        <CardTitle>{props.title}</CardTitle>
        <CardDescription>{props.description}</CardDescription>
        <div className="mt-6">{props.children}</div>
      </Card>
      <p className="text-sm text-muted">{props.footer}</p>
    </main>
  )
}
